import LoginBonusByKind from './LoginBonusByKind';

export default {
  LoginBonusByKind,
};
